/* eslint-disable prefer-destructuring */
/* eslint-disable camelcase */
/*
 * @Author: edvardchen
 * @Date: 2017-09-26 17:56:30
 * @Last Modified by: mikey.zhaopeng
 * @Last Modified time: 2021-11-05 16:04:11
 */

// @flow
import _ from 'lodash';
import querystring from 'query-string';
import qblogin from '@tencent/qblogin';
import { isAndroid } from '@tencent/qb-article-util/lib/UA';
import cookies from 'js-cookie';
import { type Dispatch, type GetState, type Article, type Action, initialState } from '../types';
import { redirect, localStorage, isHippy, postMessage, isomorphicConfig } from '../../utility';
import { checkKuaiBaoIsGuide } from '../../utility/reportDistribute';
import makeReportArticlePV from './makeReportArticlePV';
import makeRecordReadingTime from './makeRecordReadingTime';
import { reportWelfareTiming } from './makeRecordInteractiveTime';
import {
  getCorrelateVideo,
  getBriefAndPostInfo,
  getExtInfo,
  updateArticleReadingUsers,
  getDistributeInfo,
  getNowLivingFetch,
  getListAppFeedback,
  getUgInfo,
  getPraiseInfo,
  getHideArticleRowkeys,
} from '../../fetchers/article_client';
import { customerLogReport } from '../../fetchers/circle_client';
import { resetPost } from '../comment';
import { makeTrack } from '../../ducks/root';
import { setFollow, setPraise, synchState } from '../user';
import KdBigTReport from '../../entries/kdarticle/bigTReport';
import { cidToRowkey } from '@tencent/cm-rkcid';
// import Mock from './mock.json';
export { makeReportArticlePV, makeRecordReadingTime, reportWelfareTiming };
type ChannelInfo = {
  guideTab: Object,
  action: string,
  local: string,
  add?: boolean,
};
const logKey = 'channel';
const ChannelAction = {
  exposure: 1,
  click: 2,
};
const ChannelLocal = {
  header: 1,
  footer: 2,
};
/* eslint-disable  quote-props */
const adTestIdMap = {
  '101225': { share: 'gray_b_hudong', praise: 'gray_a_hudong' },
  '101224': { share: 'gray_d_hudong', praise: 'gray_c_hudong' },
  '101377': { share: 'gray_f_hudong', praise: 'gray_e_hudong' },
};
const RESET = 'article/RESET';
const UPDATE = 'article/UPDATE';

const SHOW_PUSH_ATTACH = 'article/SHOW_PUSH_ATTACH';
const RESET_GUIDETAB = 'article/RESET_GUIDETAB';
const SET_ARTICLE_CONTENT_HEIGHT = 'article/SET_ARTICLE_CONTENT_HEIGHT';
const SET_PREVENT_DISTRI_STATUS = 'article/SET_PREVENT_DISTRI_STATUS';
const SET_NOW_LIVING = 'article/SET_NOW_LIVING';
const SET_GUIDE_REPORT = 'article/set_guide_report';
const SET_UG_INFO = 'article/SET_UGDATA';
const SET_UG_NOVEL_INFO = 'article/SET_UG_NOVEL_DATA';
const SET_MINI_PROGRAM = 'article/SET_MINI_PROGRAM';
const SET_IMAGE_VIDEO = 'article/SET_IMAGE_VIDEO';
const SET_CORRELATE_VIDEO_INFO = 'article/SET_CORRELATE_VIDEO_INFO';
const SET_LIVING_ACCOUNT = 'article/SET_LIVE_ACCOUNT';
const SET_HIDE_ROWKEYS = 'article/SET_HIDE_ROWKEYS';
export const showPushAttach = () => ({ type: SHOW_PUSH_ATTACH });
export const resetGuideTab = (payload: Object) => ({ type: RESET_GUIDETAB, payload });

export const setArticleContentHeight = (payload: number) => ({
  type: SET_ARTICLE_CONTENT_HEIGHT,
  payload,
});
export const setPreventDistriStatus = (payload: *) => ({
  type: SET_PREVENT_DISTRI_STATUS,
  payload,
});
export const setNowLivingInfo = (payload: Object) => ({ type: SET_NOW_LIVING, payload });
export const setHideRowkeys = (payload: Object) => ({ type: SET_HIDE_ROWKEYS, payload });
export const setGuideReportInfo = (payload: Object) => ({ type: SET_GUIDE_REPORT, payload });
export const setUgInfo = (payload: Object) => ({ type: SET_UG_INFO, payload });
export const setUGNovel = (payload: Object) => ({ type: SET_UG_NOVEL_INFO, payload });
export const setMiniProgram = (payload: Object) => ({ type: SET_MINI_PROGRAM, payload });
export const setImageVideo = (payload: Object) => ({ type: SET_IMAGE_VIDEO, payload });
export const setLivingAccount = (payload: Object) => ({ type: SET_LIVING_ACCOUNT, payload });
export const setCorrelateVideoInfo = (payload: Object) => ({
  type: SET_CORRELATE_VIDEO_INFO,
  payload,
});
const reducer = (state: Article, { type, payload }: Action) => {
  switch (type) {
    case RESET:
      return {
        ...initialState.article,
        ...payload,
      };
    case UPDATE:
      return {
        ...state,
        ...payload,
      };
    case SHOW_PUSH_ATTACH:
      return {
        ...state,
        showPushAttach: true,
      };
    case RESET_GUIDETAB:
      return {
        ...state,
        guideTab: {
          ...payload,
        },
      };
    case SET_ARTICLE_CONTENT_HEIGHT:
      return {
        ...state,
        contentHeight: payload,
      };
    case SET_PREVENT_DISTRI_STATUS:
      return {
        ...state,
        preventDistrStatus: payload,
      };
    case SET_NOW_LIVING:
      return {
        ...state,
        LiveInfo: payload,
      };
    case SET_GUIDE_REPORT:
      return {
        ...state,
        guideReportInfo: payload,
      };
    case SET_UG_INFO:
      return {
        ...state,
        ...payload,
      };
    case SET_UG_NOVEL_INFO:
      return {
        ...state,
        ...payload,
      };
    case SET_MINI_PROGRAM:
      return {
        ...state,
        miniProgram: payload,
      };
    case SET_IMAGE_VIDEO:
      return {
        ...state,
        imageVideo: payload,
      };
    case SET_CORRELATE_VIDEO_INFO:
      return {
        ...state,
        correlateVideo: payload,
      };
    case SET_LIVING_ACCOUNT:
      return {
        ...state,
        livingAccount: payload,
      };
    case SET_HIDE_ROWKEYS:
      return {
        ...state,
        hideRowkeys: payload,
      };
    default:
      return state;
  }
};

export default reducer;

export const reset = (payload: Object) => ({ type: RESET, payload });

export const update = (payload: Object) => ({ type: UPDATE, payload });

/**
 *变更文章当前在读人数
 */
export const makeUpdateArticleReadingUsers = (direction: number = 1) => async (
  dispatch: Dispatch,
  getState: GetState,
) => {
  if (!__CLIENT__) {
    return;
  }
  const { article = {} } = getState();
  const { docId } = article;
  if (docId) {
    const { readingNum } = await updateArticleReadingUsers(docId, direction);
    article.readingUsers = readingNum;
    dispatch(update(article));
  }
};
export const makeFetchBriefAndPostInfo = (circleId?: string, postId?: string) => async (
  dispatch: Dispatch,
  getState: GetState,
) => {
  if (!__CLIENT__) {
    return;
  }
  const {
    article: { docId, url },
  } = getState();
  if (docId || url) {
    const { article, postInfo } = await getBriefAndPostInfo({ docId, url });
    if (circleId) {
      postInfo.circleId = circleId;
    }
    if (postId) {
      postInfo.postId = postId;
    }
    dispatch(resetPost(postInfo));
    dispatch(update(article));
  }
};
/**
 * 汽车之家回传数据上报
 */
export const makeAutohomeReport = (second?: number) => async (dispatch: Dispatch, getState: GetState) => {
  if (!__CLIENT__) {
    return;
  }
  const {
    article: { dataSrc, url = '', zimeitiId = '' },
  } = getState();
  if (dataSrc === 130) {
    const guid = cookies.get('qb_guid') || '';
    const ua = _.get(window, 'navigator.userAgent') || '';
    const urlObj = querystring.parse(url) || {};
    const { articleId = '' } = urlObj;
    const reportData = {
      uuid: guid,
      plat: isAndroid(ua) ? 'android' : 'ios',
      bid: articleId,
      ctime: new Date().getTime(),
      ltype: 'explore',
      source: 'QQBrowser',
      eventid: 'qb_stru_data_click',
      argv: JSON.stringify({ duration: second || 0, qierhao: zimeitiId }),
    };
    return window.fetch(`//al.autohome.com.cn/mda_data_send?${querystring.stringify(reportData)}`).then((resp) => {
      console.log(resp);
    });
  }
};
/**
 * 频道曝光上报
 *
 */
export function reportChannelInfo({ guideTab, action, local, add }: ChannelInfo) {
  const { tab: id, name, isExit } = guideTab;
  const actionType = ChannelAction[action] || 1;
  let type = 1;
  if (actionType === 2) {
    if (add) {
      type = 2;
    } else {
      type = isExit ? 3 : 2;
    }
  }
  const location = ChannelLocal[local];

  // 位置（头部：1|尾部：2）|频道id|频道name|类别（1：曝光|2：添加|3：查看）logType 1 曝光 2点击
  customerLogReport({
    logType: actionType,
    logKey,
    logContent: `${location}|${id}|${name}|${type}`,
  });
}
/**
 *
 * 图片点击上报
 * logType 1 曝光 2点击
 */

export function openImageReport({ docId, subjectId }: { docId: string, subjectId: string }) {
  customerLogReport({
    logType: 2,
    logKey: 'newspic',
    logContent: `${docId}|${subjectId}`,
  });
}
export const addChannel = async (
  tabId: string,
  guideTab: Object,
  dispatch: Dispatch,
  succ?: Function,
  error?: Function,
) => {
  const addTab = _.get(window, 'browser.feeds.addTab');
  const toast = _.get(window, 'browser.app.toast');
  if (addTab && tabId) {
    addTab(
      async () => {
        const data = Object.assign(guideTab, { isExit: true });
        await dispatch(resetGuideTab(data));
        /* isHippy() && postMessage(JSON.stringify({
        func: 'coolread.setChannelInfo',
        data
      })); */
        succ && succ(data);
        toast && toast('添加频道成功');
        data.url && redirect(data.url);
      },
      (err?: *) => {
        toast && toast('添加频道失败');
        error && error(err, guideTab);
      },
      { tabId },
    );
  }
};

/** *
 * 设置频道信息
 */
export const makeGuideTab = () => async (dispatch: Dispatch, getState: GetState) => {
  if (!__CLIENT__) {
    return;
  }
  const {
    article: { guideTab = {} },
  } = getState();
  const { tab } = guideTab || {};
  const queryTabExit = _.get(window, 'browser.feeds.queryTabExist');
  if (tab && typeof queryTabExit === 'function') {
    queryTabExit(
      (resp = {}) => {
        console.log('makeGuideTab', JSON.stringify(resp));
        const ua = _.get(window, 'navigator.userAgent') || '';
        const isAnd = isAndroid(ua);
        const isExit = `${isAnd ? resp.ret : resp.retcode}`; // ios转string
        guideTab.isExit = isExit === '1';
        /* try {
        isHippy() && postMessage(JSON.stringify({
          func: 'coolread.setChannelInfo',
          data: guideTab
        }));
      } catch (error) {
        console.log(error);
      } */
        reportChannelInfo({ guideTab, action: 'exposure', local: 'header' });
        dispatch(resetGuideTab(guideTab));
      },
      (err?: *) => {
        console.log(err);
      },
      { tabId: tab },
    );
  }
  window.feedsAddChannel = async (data) => {
    console.log('feedsAddChannel', JSON.stringify(data));
    const info = (typeof data === 'string' ? JSON.parse(data) : data) || {};
    reportChannelInfo({ guideTab, action: 'click', local: 'header', add: true });
    addChannel(info.tabId, guideTab, dispatch);
  };
  window.feedsOpenChannel = (data) => {
    console.log('feedsOpenChannel', JSON.stringify(data));
    reportChannelInfo({ guideTab, action: 'click', local: 'header' });
  };
};
/** *
 * abTest上报
 */
export const reportAbTest = ({ type, loc, grayId, ...rest }: *) => async (dispatch: Dispatch) => {
  if (grayId && adTestIdMap[grayId]) {
    dispatch(
      makeTrack({
        location: 'article',
        action: type,
        object: _.get(adTestIdMap, `${grayId}.${loc}`),
        ...rest,
      }),
    );
  }
};

export const getAbtGrayId = (abTestKey: any) => async (dispatch: Dispatch, getState: GetState) => {
  const { grayConfig = {} } = getState();
  let abtGrayId = '';
  if (!_.isEmpty(grayConfig) && abTestKey) {
    let abTestKeyTemp = [];
    if (typeof abTestKey === 'string') {
      abTestKeyTemp = [abTestKey];
    } else if (abTestKey instanceof Array) {
      abTestKeyTemp = abTestKey;
    }
    for (let i = 0; i < abTestKeyTemp.length; i += 1) {
      if (grayConfig[abTestKeyTemp[i]] && grayConfig[abTestKeyTemp[i]].isAble) {
        abtGrayId = grayConfig[abTestKeyTemp[i]].grayId;
        break;
      }
    }
  }
  return abtGrayId;
};
// 上报数据通过feeds的服务
export const feedsReport2BzServer = (readTime: number, extData: Object) => async (
  dispatch: Dispatch,
  getState: GetState,
) => {
  const wifiMap = {
    '2g': '1',
    '3g': '2',
    '4g': '3',
    wifi: '4',
  };
  const {
    apn,
    currentChannel,
    location: { query },
    article: { docId },
  } = getState();
  const { busi, ch, pid, queryId } = Object.assign(query, extData);
  isHippy() &&
    postMessage(
      JSON.stringify({
        func: 'coolread.feedsReport',
        data: {
          actionType: 'read_time',
          busi: `${busi || 1}`,
          resourceType: '1',
          readTime: `${readTime}`,
          ch: ch || currentChannel,
          eventTimeStamp: new Date().getTime(),
          networkType: wifiMap[apn.toLocaleLowerCase()] || '0',
          prod: pid,
          queryId,
          resourceId: `1_${docId}`,
        },
      }),
    );
};
// 获取正文的额外信息 目前只有内部用户信息
export const getArticleExtInfo = () => async (dispatch: Dispatch, getState: GetState) => {
  const userExtInfo = localStorage.getItem('USER_EXT_INFO');
  let extInfo = null;
  if (!userExtInfo || !userExtInfo._time || new Date().getDate() !== new Date(userExtInfo._time).getDate()) {
    const result =
      (await getExtInfo().catch((e) => {
        console.log('getArticleExtInfo_error', e);
      })) || {};
    const { mpExtInfo: { innerGuidFlag = '', readingRate, readingTime } = {} } = result;
    extInfo = {
      bInnerGuid: innerGuidFlag === '1',
      readingRate,
      readingTime,
    };
    localStorage.setItem('USER_EXT_INFO', {
      extInfo,
      _time: new Date(),
    });
  } else {
    extInfo = userExtInfo.extInfo;
  }
  if (extInfo) {
    const { article } = getState();
    const updateInfo = Object.assign(article, extInfo);
    dispatch(update(updateInfo));
  }
};

// 获取正文的额外信息 目前只有内部用户信息
export const makeListAppFeedback = () => async (dispatch: Dispatch, getState: GetState) => {
  if (!__CLIENT__) {
    return;
  }
  const { article = {} } = getState();
  const { docId } = article;
  if (docId) {
    const ret =
      (await getListAppFeedback(docId).catch((e) => {
        console.log('getListAppFeedback_error', e);
      })) || {};
    article.feedbacks = ret.feedbacks || {};
    dispatch(update(article));
    return article.feedbacks;
  }
};

// 判断当前用户是否再需要导流
export const setDistributeStatus = () => async (dispatch: Dispatch, getState: GetState) => {
  const guid = cookies.get('qb_guid') || '';
  const {
    user: { qbid = '' },
    location: { query = {}, isFastV },
  } = getState();
  if (isFastV) {
    dispatch(setPreventDistriStatus(true));
    return;
  }
  const extData = querystring.parse(query.extenddata) || {};
  const { isGuide, install, isReport } = await checkKuaiBaoIsGuide();
  if (isReport && install) {
    customerLogReport({
      logType: 1,
      contentType: 13,
      logContent: 'isInstall|1',
    });
  }
  /* 1 快报不导流 2微视不导流 3都不导流 */
  window.GUIDECONFIG = {
    kb: [1, 3].indexOf(Number(extData._dis)) > -1 || !isGuide, // 快报导流
    ws: [2, 3].indexOf(Number(extData._dis)) > -1, // 微视导流
  };
  let preventInfo = null;
  const isDistribute = window.CONSTANTS.isDistribute || '';
  const wifi = window.CONSTANTS.nowWifiName || '';
  // console.debug('======setDistributeStatus====', qbid, isDistribute, wifi);
  if (guid && isDistribute === '1') {
    const key = `${guid}_distr_preventInfo`;
    const { time, info } = localStorage.getItem(key) || {};
    if (time && new Date().getDate() === new Date(time).getDate()) {
      preventInfo = info;
      // console.debug('======setDistributeStatus-cache', info);
    } else {
      const result =
        (await getDistributeInfo({ qbid, wifi }).catch((e) => {
          console.debug('======setDistributeStatus-error', e);
        })) || {};
      // console.debug('======setDistributeStatus-server', result);
      if (result) {
        preventInfo = result.status;
        localStorage.setItem(key, {
          time: new Date().getTime(),
          info: preventInfo,
        });
      }
    }
  }
  // console.debug('======setDistributeStatus-result', preventInfo);
  dispatch(setPreventDistriStatus(preventInfo));
};
export const makeNowLivingInfo = () => async (dispatch: Dispatch, getState: GetState) => {
  const {
    article: { liveRoomId = 0 },
  } = getState();
  const result = await getNowLivingFetch(liveRoomId).catch((e) => {
    console.debug('=========makeNowLivingInfo-error', e);
  });
  dispatch(setNowLivingInfo(result));
};
export const resetGuideReport = () => async (dispatch: Dispatch, getState: GetState) => {
  const {
    article: { url, docId, subjectId, zimeitiId },
    location = {},
  } = getState();
  const { query: { ch, ctrid, dataSrc, data_type, extenddata, pid } = {} } = location;
  const extData = querystring.parse(extenddata);
  const { sStrategyId, contentLevel, sGrayPlatFormModelId, sModelId, queryId } = extData;
  const guid = cookies.get('qb_guid');
  const qua = cookies.get('qb_qua');
  const ext = {
    logType: 'access',
    url,
    docId,
    ch,
    innerCh: '',
    businessId: 'coolread',
    business: '',
    fromId: '',
    viewType: 'article',
    dataSrc,
    subjectId,
    zimeitiId,
    pid,
    data_type,
    ctrid,
    contentLevel,
    queryId,
    guid,
    qua,
    sGrayPlatFormModelId,
    sStrategyId,
    sModelId,
  };
  dispatch(setGuideReportInfo(ext));
};

const ugTipsFn = (ugTipMark, nExt, extInfo, ugRsp = {}, ugOpen) => {
  if (ugTipMark && __CLIENT__) {
    // document.addEventListener('DOMContentLoaded', () => {
    const tips = `导流开关--ugOpen=${ugOpen ? '1' : '0'};ug开关信息-nExt=${nExt};ug扩展信息-extInfo=${JSON.stringify(
      extInfo,
    )};ug服务回包信息-ugRsp=${JSON.stringify(ugRsp)}`;
    console.debug('ug tips ', tips);
    const showAlertDialog = _.get(window, 'browser.app.showAlertDialog', null);
    showAlertDialog &&
      showAlertDialog(() => {}, {
        title: '',
        content: tips,
        cancel: '取消',
        confirm: '确定',
      });
    // });
  }
};

export const makeFetchUgInfo = () => async (dispatch: Dispatch, getState: GetState) => {
  const {
    article: { docId = '', subjectId = '', tags = [] },
    location = {},
    grayConfig = {},
  } = getState();
  const guid = cookies.get('qb_guid') || '';
  const ugCloseObj = grayConfig.ugclose || {};
  const isClose = ugCloseObj && ugCloseObj.isAble;
  console.debug('makeFetchUgInfo enter grayConfig==', isomorphicConfig.ugTips, isClose);
  const ugTipAry = (isomorphicConfig.ugTips || '').split(',');
  const ugTipMark = !!(guid && ugTipAry.indexOf(guid) !== -1);
  if (!isClose) {
    const nExt = _.get(location, 'query.nExt', '');
    let ugOpen = false;
    let extInfo = {};
    let ugExtInfo = {};
    const extenddata = _.get(location, 'query.extenddata', '');
    if (extenddata) {
      const { _ug, ...rest } = querystring.parse(extenddata) || {};
      ugOpen = !!_ug;
      extInfo = rest;
    }
    if (nExt) {
      const _nExt = JSON.parse(nExt) || {}; // 兼容feeds传过来的开关
      const { ugDiversionInfo = {} } = _nExt;
      ugOpen = true;
      extInfo = Object.assign(extInfo, ugDiversionInfo);
      ugExtInfo = ugDiversionInfo;
    }
    let result = null;
    if (ugOpen) {
      const tagObj = tags.map((tag = {}) => ({ sTagId: tag.lTagId, sTagName: tag.sTagName })).filter(Boolean);
      const tagInfo = JSON.stringify(tagObj);
      console.log(
        '请求ug',
        JSON.stringify({
          docId,
          extInfo,
          subjectId,
          tagInfo: encodeURIComponent(tagInfo),
          ugExtInfo,
        }),
      );
      result = await getUgInfo({
        docId,
        extInfo,
        subjectId,
        tagInfo: encodeURIComponent(tagInfo),
        ugExtInfo,
      }).catch((e) => {
        console.debug('=========getUgInfo-error', e);
      });
      if (result && result.retCode === 0 && result.data) {
        const { ugGuideData = {} } = result.data || {};
        const { privateInfo: { uiType } = {} } = ugGuideData;
        if (uiType === 220) {
          result.data.isUgGuide = false;
        }
        dispatch(setUgInfo(Object.assign({}, result.data, { isUg: ugOpen })));
      }
    }

    ugTipsFn(ugTipMark, nExt, extInfo, result, ugOpen);
  }
};
export const makeFetchUgNovel = () => {};
// export const makeFetchUgNovel = () => async (dispatch: Dispatch, getState: GetState) => {
//   const {
//     article: { docId = '' },
//   } = getState();
//   const { getNovelData } = require('@tencent/news-ug-component');
//   const novelData = await getNovelData({
//     posid: 100444,
//     docId,
//   });
//   console.log('fetch novel data', novelData);
//   dispatch(setUgInfo({ novelData }));
// };
export const makeImageVideoInfo = (info: Object) => async (dispatch: Dispatch) => {
  dispatch(setImageVideo(info));
};
export const makeCorrelateVideoInfo = () => async (dispatch: Dispatch, getState: GetState) => {
  const {
    user: { qbid = '' },
    article: { docId = '', tagDefaultInfo = [] },
    location,
    grayConfig = {},
  } = getState();
  const { query: { ch = '', pid = '' } = {} } = location || {};
  const tagList = tagDefaultInfo.map((info) => {
    const { name, score, id } = info || {};
    return { tag_id: id, tag_name: name, weight: score };
  });
  let num = 3;
  if (grayConfig.corVideo2 && grayConfig.corVideo2.isAble) {
    num = 1;
  }
  const result = await getCorrelateVideo({
    qbid,
    ch,
    docId,
    pid,
    num,
    tagList: encodeURIComponent(JSON.stringify(tagList)),
  });
  const videoList = [];
  const { recomm_info = [] } = result || {};
  if (recomm_info && recomm_info.length) {
    recomm_info.forEach((_info) => {
      const vidInfo = _info;
      if (vidInfo) {
        const { image_url, runtime, vid, title, jump_url, media_info } = vidInfo || {};
        const obj = {
          imageUrl: image_url,
          title,
          totalTime: runtime,
          vid,
          jump_url,
          media_info,
        };
        videoList.push(obj);
      }
    });
    await dispatch(setImageVideo(videoList));
  }
  return videoList;
};
// 区分直播和预约数据
const pickLivingInfo = (infos) => {
  let living = null;
  for (let i = 0; i < infos.length; i++) {
    const item = infos[i];
    const { work_type, live_info, program_info } = item;
    if (work_type === 2 && live_info) {
      living = Object.assign({ live_info }, { work_type });
      break;
    }
    if (living) {
      break;
    } else {
      if (work_type === 3 && program_info) {
        const { jump_url, title, ...rest } = program_info;
        living = { live_info: { ...rest, work_type, qbUrl: jump_url, room_name: title } };
      }
    }
  }
  return living;
};
export const makeLivingAccountInfo = () => async (dispatch: Dispatch, getState: GetState) => {
  const {
    article: { puin = '' },
    grayConfig = {},
  } = getState();
  if (grayConfig.noLiveRoom && grayConfig.noLiveRoom.isAble) {
    return;
  }
  if (puin) {
    const ua = _.get(window, 'navigator.userAgent') || '';
    const qua = cookies.get('qb_qua');
    const grayIds = cookies.get('BUCKETS') || '';
    const body = {
      puin,
      qua,
      clientType: isAndroid(ua) ? 1 : 2,
      abtokenArgs: {
        abtoken_type: 1,
        nettype: '3',
        ui: '',
        gid: grayIds,
      },
      reqType: 'imageText',
    };
    const setLivingInfo = (r = {}) => {
      const { retcode, result } = r;
      if (retcode === 0 && result) {
        const { infos = [] } = result || {};
        let _infos = null;
        if (infos.length) {
          _infos = infos;
          const info = pickLivingInfo(_infos);
          if (!info) {
            return;
          }
          const {
            live_info: {
              room_name,
              qbUrl,
              cover_type,
              cover_horizontal,
              cover_vertical,
              playUrl,
              room_id,
              work_type,
              cover_url,
            } = {},
          } = info;
          const liveInfo = {
            room_name,
            qbUrl,
            cover_type,
            cover_horizontal,
            cover_vertical,
            playUrl,
            puin,
            room_id,
            work_type,
            cover_url,
          };
          console.debug('~~~~~~~~~~~~~~~~setLivingInfo', JSON.stringify(liveInfo));
          postMessage(
            JSON.stringify({
              func: 'coolread.liveInfo',
              data: liveInfo,
            }),
          );
          dispatch(setLivingAccount(liveInfo));
        }
      }
    };
    // setLivingInfo(Mock);
    const xhr = new XMLHttpRequest();
    xhr.open('POST', 'https://ias.now.qq.com/cgi-bin/qb_live/tlive_user_live_data_http_api/get_live_tab_messages');
    // xhr.setRequestHeader('content-type', 'application/json');
    xhr.onreadystatechange = () => {
      if (xhr.readyState === 4 && xhr.status === 200) {
        const r = JSON.parse(xhr.responseText) || {};
        setLivingInfo(r);
      }
    };
    xhr.send(JSON.stringify(body));
  }
};

export const setKdPraiseStatus = () => async (dispatch: Dispatch, getState: GetState) => {
  const user = await qblogin.getSession();
  const {
    article: { rowkey },
  } = getState();
  const guid = cookies.get('qb_guid') || '';
  const isPraise = await getPraiseInfo({
    user: { user_id: guid, account_type: 3 }, // 3用于guid游客态点赞
    user_session: {
      session: { session_key: user.sk, session_auth: user.sa },
    },
    rowkeys: [rowkey],
    smart_type: 0,
    business_type: 2,
  });
  let noLoginPraise = localStorage.getItem('noLoginPraise');
  if (typeof noLoginPraise !== 'object') noLoginPraise = JSON.parse(noLoginPraise) || [];
  if (isPraise[rowkey] || noLoginPraise.indexOf(rowkey) > -1) {
    dispatch(setPraise(true));
    return true;
  }
  dispatch(setPraise(false));
  return false;
};

export const setKdFollowStatus = (reportInstance: KdBigTReport, needReport: boolean = false) => async (
  dispatch: Dispatch,
  getState: GetState,
) => {
  const {
    article: { fusionId, account_type },
  } = getState();
  const puin = fusionId?.split('_')[1] || '';
  const QBLoginSyncModule = require('@tencent/qb-login-sync-module');
  try {
    // 看点图文关注链路与以前不同 先获取是否关注了该作者
    const isFollow = await QBLoginSyncModule.qqkdQueryFollowStatus(
      [
        {
          user_id: puin, // puin_3601378623
          account_type, // 15
        },
      ],
      {
        app_type: 5,
        app_id: 'KDTABArticlePage',
      },
      // `${grayConfig.env === 'test' ? 'test' : 'real'}`,
    );
    if (isFollow.result && isFollow.result[puin] === 1) {
      dispatch(setFollow(true));
      synchState({ id: fusionId, state: true }); // 同步关注状态
      // 关注按钮上报 因为只有当这个请求走完了才会显示上报按钮
      if (needReport) reportInstance?.report('followBtnShow', { r5: { button_type: 2 } });
    } else {
      dispatch(setFollow(false));
      if (needReport) reportInstance?.report('followBtnShow', { r5: { button_type: 2 } });
    }
  } catch (error) {
    dispatch(setFollow(false));
    if (needReport) reportInstance?.report('followBtnShow', { r5: { button_type: 2 } });
    console.warn(error);
  }
};

export const setHideArticleRowkeys = () => async (dispatch: Dispatch, getState: GetState) => {
  const {
    article: { docId = '' },
  } = getState();
  const rowkey = cidToRowkey(docId);
  const result = await getHideArticleRowkeys().catch((e) => {
    console.debug('=========getHideArticleRowkeys-error', rowkey, e);
  });
  console.log('hide rowkeys ===', result);
  const filterMap = new Set();
  result?.data?.forEach((item) => {
    filterMap.add(item.rowkey);
    // 无极通过url筛选出符合条件的数据了 不需要再前端判断了
    // if ((item.app === '2' || item.app === '4') & (item.deadtime >= Date.now())) {}
  });
  dispatch(setHideRowkeys(filterMap));
};
